export enum FormSelectOptionsSwitchBlock {
  Root = 'FormSelectOptionsSwitch',
}

export enum FormSelectOptionsSwitchElement {
  Control = 'control',
  Select = 'select',
}
